'use es6';
/** @module debounce */

/** Ensures a given task doesn't fire so often as to brick browser
 * performance. Returns a function, that, as long as it continues
 * to be invoked, will not be triggered.
 *
 * Usage:
 *   // Place your code within {}
 *   const myEfficientFn = debounce(() => {}, 250);
 *   window.addEventListener('resize', myEfficientFn);
 */

export default ((func, wait, immediate) => {
  let timeout;
  return (...args) => {
    const later = () => {
      timeout = null;

      if (!immediate) {
        func.apply(this, args);
      }
    };

    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) {
      func.apply(this, args);
    }
  };
});